
document.addEventListener('DOMContentLoaded', function () {

    let updateButton = document.querySelector('#updateButton');
    let inputAmount = document.querySelector('#customAmount');
    let amountDisplay = document.querySelector('#customInputAmount');
    let productPrice = document.querySelector('.calcPrice');
    let taxLine = document.querySelector('.product__tax');
    let nameInput = document.querySelector('#customInputName');
    if (nameInput) {
        nameInput.value = "";
    }
    if (inputAmount) {
        inputAmount.value = "";
    }

    let pickYourPrice = false;
    let isDigital = false;
    let buyButtons = document.querySelector('product-form');

    if (pickYourPrice === true) {
        buyButtons.style.display = 'none';
    }
    if (isDigital === true) {
        nameInput.style.display = 'none';
    }

    function labelClick() {
        pickYourPrice = true;
        amountDisplay.style.display = 'flex';
        productPrice.style.display = 'none';
        taxLine.style.display = 'none';
        buyButtons.style.display = 'none';
    }
    function removeLabel() {
        pickYourPrice = false;
        amountDisplay.style.display = 'none';
        productPrice.style.display = 'block';
        taxLine.style.display = 'block';
        buyButtons.style.display = 'block';
        inputAmount.value = "";
        if (isDigital === true) {
            nameInput.style.display = 'none';
        }
    }

    function digitalClick() {
        isDigital = true;
        nameInput.style.display = 'none';

    }

    function physicalClick() {
        isDigital = false;
        nameInput.style.display = 'flex';
    }

    function handleQuantity() {
        customAmount = parseFloat(inputAmount.value.replace(",", "."));
        if (!isNaN(customAmount) && customAmount >= 50) {
            let peiceDecider = 0.50;
            let quantity = customAmount / peiceDecider;
            let quantitySelector = document.querySelector('input[name="quantity"]');
            quantitySelector.value = Math.floor(quantity);
            calcPrice = (quantitySelector.value / 2).toFixed(2);
            console.log('quantitySelector.value', quantitySelector.value);
            console.log('calcPrice', calcPrice);
            let priceShown = calcPrice.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            let priceField = productPrice.querySelector('.price-item');
            priceField.textContent = 'Indtastet pris ' + priceShown + ' DKK';
            productPrice.style.display = 'block';
            buyButtons.style.display = 'block';
        } else {
            window.alert('Beløbet skal være over 50 Kr.')
        }
    }

    let typeDropdown = document.querySelector('select[name="options[Bevis]"]'),
        priceDropdown = document.querySelector('select[name="options[Pris]"]');
    let typeOptions, priceOptions;

    if (typeDropdown) {
        typeOptions = typeDropdown.querySelectorAll('option');
    }
    if (priceDropdown) {
        priceOptions = priceDropdown.querySelectorAll('option');
    }

    if (typeOptions) {
        typeOptions.forEach(typeOption => {
            let typeValue = typeOption.value;
            if (typeValue === 'Digitalt') {
                if (typeOption.hasAttribute('selected')) {
                    digitalClick();
                }
            } else if (typeValue === 'Fysisk') {
                if (typeOption.hasAttribute('selected')) {
                    physicalClick();
                }
            }
        })
    }
    function handleType(event) {
        let selectedType = event.target.options[event.target.selectedIndex].text;

        if (selectedType === 'Digitalt') {
            digitalClick();
        } else if (selectedType === 'Fysisk') {
            physicalClick();
        }
    }
    if (priceOptions) {
        priceOptions.forEach(priceOption => {
            let priceValue = priceOption.value;
            if (priceValue === 'Vælg anden pris') {
                if (priceOption.hasAttribute('selected')) {
                    labelClick();
                }
            } else {
                removeLabel();
            }
        });
    }
    function handlePrice(event) {
        let selectedPrice = event.target.options[event.target.selectedIndex].text;

        if (selectedPrice === 'Vælg anden pris') {
            labelClick();
        } else {
            removeLabel();
        }
    }

    if (typeDropdown) {
        typeDropdown.addEventListener('change', handleType);
    }
    if (priceDropdown) {
        priceDropdown.addEventListener('change', handlePrice);
    }

    /* let productInputs = document.querySelectorAll('.product-form__input');
    productInputs.forEach(input => {
        let labels = input.querySelectorAll('label');
        labels.forEach(label => {
            if (label.textContent.includes('Vælg anden pris')) {
                let inputElement = label.previousElementSibling;
                label.addEventListener('click', labelClick)
                if (inputElement && inputElement.type === 'radio' && inputElement.checked) {
                    labelClick();
                }
            } else if (label.textContent.includes('kr')) {
                label.addEventListener('click', removeLabel);
            } else if (label.textContent.includes('Digitalt')) {
                let inputElement = label.previousElementSibling;
                label.addEventListener('click', digitalClick)
                if (inputElement && inputElement.type === 'radio' && inputElement.checked) {
                    digitalClick();
                }
            } else if (label.textContent.includes('Fysisk')) {
                let inputElement = label.previousElementSibling;
                label.addEventListener('click', physicalClick)
                if (inputElement && inputElement.type === 'radio' && inputElement.checked) {
                    physicalClick();
                }
            }
        });
    }); */
    if (updateButton) {
        updateButton.addEventListener('click', handleQuantity);
    }


    // Cart changes to prevent amount changing
    function cartUpdate() {
        let customCartItem = document.querySelectorAll('.cart-item');
        if (customCartItem) {
            customCartItem.forEach(customItem => {
                let giftCardReader = customItem.querySelectorAll('.product-option');
                let currentCustomItem = customItem;
                let customItemName = customItem.querySelector('.cart-item__name');
                giftCardReader.forEach(productOption => {
                    if (productOption.textContent.includes('Vælg anden pris')) {
                        let remover = currentCustomItem.querySelectorAll('.product-option');
                        let quantityRemove = currentCustomItem.querySelector('.quantity-popover-container');
                        quantityRemove.style.display = 'none';
                        let removeIcon = currentCustomItem.querySelector('cart-remove-button');
                        removeIcon.style.margin = '0';
                        remover.forEach(removeOption => {
                            if (removeOption.textContent.includes('kr')) {
                                removeOption.style.display = 'none';
                            }
                            if (removeOption.textContent.includes('Vælg anden pris')) {
                                removeOption.style.display = 'none';
                            }
                        })
                    }
                })
                if (customItemName.textContent.includes('Naturgavekort')) {
                    let quantityRemove = currentCustomItem.querySelector('.quantity-popover-container');
                    quantityRemove.style.display = 'none';
                    let removeIcon = currentCustomItem.querySelector('cart-remove-button');
                    removeIcon.style.margin = '0';
                }
            })
        }
    }

    cartUpdate();
    window.addEventListener('click', cartUpdate)
});
